import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How do I place an order?",
    a: "Send the order form below, message us on WhatsApp, or call the 24/7 helpline. Every order gets a reference ID (like CBH-XXXXXX) that you can quote anytime for a status update.",
  },
  {
    q: "How fast is the turnaround?",
    a: "We work 24 hours a day, 7 days a week. Tell us your deadline when you order — urgent work is prioritised and the timeline is confirmed with you before work begins.",
  },
  {
    q: "Do you handle revisions?",
    a: "Yes. Message us on WhatsApp or email with your reference ID and what needs changing. The revision scope is agreed with you before work starts.",
  },
  {
    q: "How does online tutoring work?",
    a: "One-on-one live online sessions in Mathematics, Statistics and Physics, scheduled around your timezone — day or night, including exam preparation and research support.",
  },
  {
    q: "Which tools and subjects do you cover?",
    a: "Websites and mobile apps, AI chatbots, Matlab, Mathematica and Python programming, LaTeX typesetting, research articles, PhD proposals, and tutoring in Math, Statistics and Physics.",
  },
  {
    q: "Is my research or project kept confidential?",
    a: "Yes. Your documents, code and project details are never shared with third parties.",
  },
  {
    q: "How do I check my order status?",
    a: "Use the Track Order tab under the contact form with your reference ID and phone number — or simply message us on WhatsApp quoting your reference.",
  },
];

const FAQ = () => (
  <section id="faq" className="py-24 px-6 border-b border-white/5" data-testid="faq-section">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <span className="text-xs font-mono uppercase tracking-widest text-pink-400">Before You Ask</span>
        <h2 className="font-poster text-4xl sm:text-5xl uppercase tracking-normal text-white mt-1">
          Frequently Asked Questions
        </h2>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="border-white/10"
          >
            <AccordionTrigger className="text-white text-sm font-bold hover:text-pink-300 hover:no-underline">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-slate-400 leading-relaxed">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
